module.exports = __webpack_public_path__ + "static/img/nc7.2df0849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nc7.png
// module id = +Nla
// module chunks = 73